import { defineComponent as _defineComponent } from 'vue';
import FormDrilldownOption from "./FormDrilldownOption.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDrilldownList',
    props: {
        currentValue: null,
        handleClick: null,
        multiple: { type: Boolean },
        showIcons: { type: Boolean },
        options: null
    },
    setup(__props) {
        return { __sfc: true, FormDrilldownOption };
    }
});
